import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { TextModes } from '../controls/text-input/text-input.component';
import { FormMode } from '../../../core/constants';
import { UIHelpers } from '../../../core/ui-helpers';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AssignedUser } from '../../../models/users/assignedUser';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactFormComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class ContactFormComponent implements ControlValueAccessor {
  @Input() contact: AssignedUser | undefined;
  @Input() formMode: FormMode = FormMode.View;
  @Input() readonly: boolean = false;
  @Output() onediting = new EventEmitter<AssignedUser>();
  @Output() onsave = new EventEmitter<AssignedUser>();
  @Output() oncancel = new EventEmitter<void>();
  @Output() ondelete = new EventEmitter<AssignedUser>();

  formModes = FormMode;
  inputTextModes = TextModes;
  IconType = IconType;
  contactTypeOptions = AssignedUser.ALL_CONTACT_TYPES;
  uiHelpers = UIHelpers;

  editableContact: AssignedUser = AssignedUser.createEmpty();
  selectedContactTypes: Record<string, boolean> = {};

  ALL_CONTACT_TYPES = AssignedUser.ALL_CONTACT_TYPES;

  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(contact: AssignedUser): void {
    this.contact = contact;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor() {}

  ngOnInit() {
    if (this.contact) {
      this.editableContact = AssignedUser.clone(this.contact as AssignedUser);
      for (let contactType of this.editableContact.contactTypes) {
        this.selectedContactTypes[contactType] = true;
      }
    }
  }

  public get(): AssignedUser | undefined {
    return this.contact;
  }

  btnEdit_click() {
    if (this.contact) {
      this.onediting.emit(this.contact);
    }
  }

  btnSave_click() {
    // if (this.editableContact.streetAddress) {
    //   this.editableContact.streetAddress.street1 = this.editableContact.streetAddress.street1?.trim();
    //   this.editableContact.streetAddress.street2 = this.editableContact.streetAddress.street2?.trim();
    //   this.editableContact.streetAddress.city = this.editableContact.streetAddress.city?.trim();
    //   this.editableContact.streetAddress.state = this.editableContact.streetAddress.state?.trim();
    //   this.editableContact.streetAddress.postalCode = this.editableContact.streetAddress.postalCode?.trim();
    //   this.editableContact.streetAddress.country = this.editableContact.streetAddress.country?.trim();
    // }
    this.editableContact.contactTypes = Object.keys(
      this.selectedContactTypes,
    ).filter((key) => this.selectedContactTypes[key]);
    this.onsave.emit(this.editableContact);
  }

  btnDelete_click() {
    this.ondelete.emit(this.contact);
  }

  btnCancel_click() {
    this.oncancel.emit();
  }
}
